import React from 'react';
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../AuthContext';

const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;


// TO BE DELETED 


function Home() {
  const navigate = useNavigate();
  const { userData } = useContext(AuthContext);

  //call handleResponserError function when fetching anything to run refreshAccessToken
  const refreshAccessToken = async () => {
    try {
      const response = await fetch(`${baseUrl}/refresh-admin`, {
        credentials: 'include',
      });
      if (response.status === 403 || response.status === 401) {
        navigate('/login-admin');
        localStorage.removeItem('accessToken');
        return [];
      }
      const data = await response.json();
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('userid', data.userid);
      console.log(data);
      return;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    const roles = userData.roles;
    console.log(roles);
    if (!roles) {
      // User does not have the required role(s), redirect them to the homepage or show an error message
      console.log('No role, going to login');
      navigate('/login');
    } else {
      const isAdmin = roles.includes('admin');
      console.log(isAdmin);
      if (!isAdmin) {
        // User does not have the required role(s), redirect them to the homepage or show an error message
        // alert("you're not admin");
        console.log('Not admin, redirecting to homepage');
        navigate('/homepage');
      }
    }
  }, []);

  const redirectToUsers = () => {
    navigate('/users');
  };

  // const onHandleLogout = async () => {
  //   try {
  //     await fetch(`${baseUrl}/logout-admin`, {
  //       method: 'PUT',
  //       credentials: 'include',
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  //   localStorage.removeItem('accessToken');
  //   localStorage.removeItem('admin_id');
  //   localStorage.removeItem('roles');
  //   navigate('/');
  // };

  // const handleResponseError = (response) => {
  //   if (response.status === 403) {
  //     refreshAccessToken(); // Call refreshAccessToken only on 403 error
  //   }
  //   // Handle other response errors if needed
  //   return response;
  // };

  return (
    <div className="App">
      <header className="App-header">
        <div className="hero min-h-screen bg-base-200">
          <div className="hero-content text-center">
            <div className="max-w-md">
              <h1 className="text-5xl font-bold mb-5">Admin Home page</h1>
              <button className="btn btn-primary" onClick={redirectToUsers}>
                View all users
              </button>
              <Link to="/admin">
                <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md text-lg">
                  Go to Admin Dashboard
                </button>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Home;
